import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const NAV = [
  { group: 'Principal', items: [
    { to: '/admin',               label: 'Dashboard',       icon: '📊', exact: true },
    { to: '/admin/analytics',     label: 'Analytics',       icon: '📈' },
  ]},
  { group: 'Catálogo', items: [
    { to: '/admin/productos',     label: 'Productos',       icon: '🌿' },
    { to: '/admin/categorias',    label: 'Categorias',      icon: '🏷️' },
    { to: '/admin/resenas',       label: 'Reseñas',         icon: '⭐' },
  ]},
  { group: 'Ventas', items: [
    { to: '/admin/pedidos',       label: 'Pedidos',         icon: '📋' },
    { to: '/admin/facturacion',   label: 'Facturación',     icon: '🧾' },
    { to: '/admin/clientes',      label: 'Clientes',        icon: '👥' },
    { to: '/admin/cupones',       label: 'Cupones',         icon: '🎟️' },
    { to: '/admin/noticias',      label: 'Noticias',        icon: '📰' },
  ]},
  { group: 'Marketing', items: [
    { to: '/admin/landing-pages', label: 'Landing Pages',   icon: '🚀' },
  ]},
  { group: 'Finanzas', items: [
    { to: '/admin/finanzas',      label: 'Costos & Gastos', icon: '💰' },
  ]},
  { group: 'Sistema', items: [
    { to: '/admin/configuracion', label: 'Configuración',   icon: '⚙️' },
  ]},
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    toast.success('Sesión cerrada');
    navigate('/admin/login');
  };

  const SidebarContent = () => (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>
      {/* Header */}
      <div style={{ padding:'20px 16px', borderBottom:'1px solid rgba(255,255,255,0.08)', display:'flex', alignItems:'center', gap:10 }}>
        <span style={{ fontSize:22 }}>🌿</span>
        <div>
          <div style={{ fontFamily:"var(--font-display)", color:"#9FBE6A", fontSize:18, lineHeight:1 }}>Wawita</div>
          <div style={{ color:"rgba(255,255,255,0.35)", fontSize:10, marginTop:2 }}>Panel Admin</div>
        </div>
        <button onClick={() => setMenuOpen(false)} style={{ marginLeft:"auto", background:"none", border:"none", color:"rgba(255,255,255,0.4)", cursor:"pointer", fontSize:20, padding:4, display:"none" }} className="admin-close-btn">✕</button>
      </div>

      {/* Nav */}
      <nav style={{ flex:1, overflowY:"auto", padding:"8px" }}>
        {NAV.map(group => (
          <div key={group.group} style={{ marginBottom:8 }}>
            <div style={{ fontSize:9, fontWeight:700, color:"rgba(255,255,255,0.25)", letterSpacing:1.2, textTransform:"uppercase", padding:"10px 10px 4px" }}>{group.group}</div>
            {group.items.map(item => (
              <NavLink key={item.to} to={item.to} end={item.exact}
                onClick={() => setMenuOpen(false)}
                style={({ isActive }) => ({
                  display:"flex", alignItems:"center", gap:10, padding:"10px 12px", borderRadius:8,
                  fontSize:14, fontWeight:700, color: isActive ? "#fff" : "rgba(255,255,255,0.55)",
                  background: isActive ? "rgba(159,190,106,0.25)" : "transparent",
                  marginBottom:2, transition:"all 0.15s", textDecoration:"none"
                })}>
                <span style={{ fontSize:16, width:20, textAlign:"center" }}>{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div style={{ padding:"12px 16px", borderTop:"1px solid rgba(255,255,255,0.08)" }}>
        <div style={{ fontSize:12, color:"rgba(255,255,255,0.5)", marginBottom:8, fontWeight:600 }}>{user?.nombre}</div>
        <div style={{ display:"flex", gap:8 }}>
          <a href="/" target="_blank" rel="noreferrer" style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", gap:6, padding:"8px 10px", borderRadius:8, background:"rgba(255,255,255,0.07)", color:"rgba(255,255,255,0.6)", fontSize:12, fontWeight:700, textDecoration:"none" }}>
            🛍️ Tienda
          </a>
          <button onClick={handleLogout} style={{ padding:"8px 14px", borderRadius:8, background:"rgba(255,255,255,0.07)", border:"none", color:"rgba(255,255,255,0.6)", fontSize:12, fontWeight:700, cursor:"pointer" }}>
            ↩ Salir
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ display:"flex", height:"100vh", overflow:"hidden", background:"var(--cream)" }}>

      {/* Sidebar desktop */}
      <aside style={{ width:220, minWidth:220, background:"var(--forest)", display:"flex", flexDirection:"column" }} className="admin-sidebar-desktop">
        <SidebarContent />
      </aside>

      {/* Overlay móvil */}
      {menuOpen && (
        <div onClick={() => setMenuOpen(false)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:998 }} />
      )}

      {/* Sidebar móvil drawer */}
      <aside style={{
        position:"fixed", top:0, left:0, bottom:0, width:260,
        background:"var(--forest)", zIndex:999,
        transform: menuOpen ? "translateX(0)" : "translateX(-100%)",
        transition:"transform 0.25s ease",
        display:"flex", flexDirection:"column"
      }} className="admin-sidebar-mobile">
        <SidebarContent />
      </aside>

      {/* Main */}
      <main style={{ flex:1, display:"flex", flexDirection:"column", overflow:"hidden", minWidth:0 }}>
        {/* Top bar móvil */}
        <div style={{ display:"none", alignItems:"center", gap:12, padding:"12px 16px", background:"var(--forest)", borderBottom:"1px solid rgba(255,255,255,0.08)" }} className="admin-topbar-mobile">
          <button onClick={() => setMenuOpen(true)} style={{ background:"none", border:"none", color:"#9FBE6A", fontSize:22, cursor:"pointer", padding:0, lineHeight:1 }}>☰</button>
          <span style={{ fontFamily:"var(--font-display)", color:"#9FBE6A", fontSize:16, fontWeight:700 }}>Wawita Admin</span>
        </div>

        <div style={{ flex:1, overflowY:"auto" }}>
          <Outlet />
        </div>
      </main>

      <style>{`
        @media (max-width: 768px) {
          .admin-sidebar-desktop { display: none !important; }
          .admin-topbar-mobile { display: flex !important; }
          .admin-close-btn { display: block !important; }
        }
        @media (min-width: 769px) {
          .admin-sidebar-mobile { display: none !important; }
        }
      `}</style>
    </div>
  );
}
